import React, { useContext, useEffect, useMemo, useState } from 'react';
import { DataLayerEventContext } from '../contexts/dataLayerEventContext';
import PrlSignFlow from '../components/sms-feedback/26ua-prl-sign';
import MrlbFlow from '../components/sms-feedback/26ua-mrlb';
import CheFlow from '../components/sms-feedback/26ua-che';
import { ScreensContext } from '../contexts/screensContext';
import useScreenHistory from '../hooks/useScreenHistory';

// Форма зворотного зв'язку для SMS-каналу:
// https://yourjourney.com.ua/sms-feedback?campaign_name={sku_code}&channel=sms
//
// Механіка (авторизація -> опитувальник -> подяка) у всіх брендів однакова,
// але дизайн у кожного свій, тому флоу лежить окремою папкою під кожен SKU:
// src/components/sms-feedback/<sku>. Новий бренд = нова папка + рядок у мапі
// нижче; чужі флоу при цьому не чіпаються.
//
// Всього кодів три: 26UA-PRL-Sign, 26UA-MRLB і 26UA-CHE. Marlboro і
// Chesterfield у документах клієнта зустрічаються і як 26UA-MLB / 26UA-CHES,
// тому обидва написання ведуть на той самий флоу — інакше посилання з таким
// кодом впало б у DEFAULT_FLOW і показало б чужий бренд.
const FLOWS = {
  '26UA-PRL-Sign': PrlSignFlow,
  '26UA-MRLB': MrlbFlow,
  '26UA-MLB': MrlbFlow,
  '26UA-CHE': CheFlow,
  '26UA-CHES': CheFlow
};

// Якщо в посиланні прийде код, якого ще немає в мапі (або campaign_name
// загубиться), показуємо перший флоу, а не порожній екран.
const DEFAULT_FLOW = PrlSignFlow;

const getCampaignName = () =>
  new URLSearchParams(window.location.search).get('campaign_name') || '';

const SmsFeedback = () => {
  const { screenNumber, setScreenNumber } = useScreenHistory({
    initialScreen: 101,
    initialState: {}
  });
  const [isDisplayedAll, setIsDisplayedAll] = useState(false);
  const [endSessionType, setEndSessionType] = useState('SESSION_END');

  const { init } = useContext(DataLayerEventContext);

  const campaignName = getCampaignName();

  // Ключі в мапі — це sku_code з посилання, регістр у SMS може відрізнятися.
  const Flow = useMemo(() => {
    const key = Object.keys(FLOWS).find(
      (sku) => sku.toLowerCase() === campaignName.toLowerCase()
    );

    return key ? FLOWS[key] : DEFAULT_FLOW;
  }, [campaignName]);

  useEffect(() => {
    if (campaignName) init(campaignName);
  }, [init, campaignName]);

  return (
    <ScreensContext.Provider
      value={{
        endSessionType,
        setEndSessionType,
        isDisplayedAll,
        setIsDisplayedAll
      }}
    >
      <Flow
        innerScreenNumber={screenNumber}
        setInnerScreenNumber={(val) => setScreenNumber(val)}
      />
    </ScreensContext.Provider>
  );
};

export default SmsFeedback;
